import { 
    // Page, 
    Text, 
    View
} from '@react-pdf/renderer';

import { styles } from '../styles/styles';

export function FooterStyle1({ document }){

    return (
        <View 
            style={{
                position: 'absolute',
                bottom: 0,
                marginHorizontal: 20,
                marginBottom: 20,
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderTopColor: '#000',
                borderTopStyle: 'dotted',
                borderTopWidth: 1,
                paddingTop: 5,
                width: "100%",
            }}
        >
            <Text style={[styles.h9, { marginBottom: 5, }]}>
                Prepared by <Text style={[styles.textBold, styles.textUpperCase]}>{document?.ax_createusername} - {document?.ax_createdatetime}</Text>
            </Text>
        </View>
    )

}

export function FooterStyle2({ document }){

    const RenderFooter = ({ label }) => {
        return (
            <View style={{ marginTop: 10 }}>
                <View>
                    <Text style={[styles.h8, { paddingBottom: 5 }]}>{label}</Text>
                </View>
                <View
                    style={{
                        borderBottomColor: '#000',
                        borderBottomStyle: 'solid',
                        borderBottomWidth: 0.5,
                    }}
                ><></></View>
            </View>
        )
    }

    return (
        <View 
            style={{
                position: 'absolute',
                bottom: 0,
                marginHorizontal: 20,
                marginBottom: 20,
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderTopColor: '#000',
                borderTopStyle: 'dotted',
                borderTopWidth: 1,
                paddingTop: 5,
                width: "100%",
            }}
        >
            <View style={{ width: "55%" }}>
                <Text style={[styles.h9, { marginBottom: 5, }]}>
                    Prepared by <Text style={[styles.textBold, styles.textUpperCase]}>{document?.ax_createusername} - {document?.ax_createdatetime}</Text>
                </Text>
                <View
                    style={{
                        borderTopWidth: 1,
                        borderTopStyle: 'solid',
                        borderTopColor: '#000',

                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#000',

                        borderLeftWidth: 1,
                        borderLeftStyle: 'solid',
                        borderLeftColor: '#000',

                        borderRightWidth: 1,
                        borderRightStyle: 'solid',
                        borderRightColor: '#000',

                        // paddingTop: 55,
                        // paddingBottom: 5,
                        // paddingLeft: 4,
                        // paddingRight: 4,
                        height: 60,
                        paddingLeft: 5,
                        paddingBottom: 3,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start'
                    }}
                >

                    <Text style={[styles.h8, { marginBottom: 2, textAlign: "center" }]}>
                        Company Chop & Signature
                    </Text>
                </View>
                <Text style={[styles.h8, { marginTop: 3 }]}>
                    This is a computer-generated document. No signature is required.
                </Text>
            </View>

            <View style={{ width: "43%", alignItems: "right" }}>
                <RenderFooter label={`Name (as per IC)`} />
                <RenderFooter label={`IC / Passport No.`} />
                <RenderFooter label={`Date`} />
            </View>
        </View>
    )
}

export function FooterStyle3(props){

    const {
        document
    } = props

    return (
        <View 
            style={{
                position: 'absolute',
                bottom: 0,
                marginHorizontal: 20,
                marginBottom: 20,
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderTopColor: '#000',
                borderTopStyle: 'dotted',
                borderTopWidth: 1,
                paddingTop: 5,
                width: "100%",
            }}
        >
            <View style={{ width: "55%" }}>
                <Text style={[styles.h9, { marginBottom: 5, }]}>
                    Prepared by <Text style={[styles.textBold, styles.textUpperCase]}>{document?.ax_createusername} - {document?.ax_createdatetime}</Text>
                </Text>
                <View
                    style={{
                        borderTopWidth: 1,
                        borderTopStyle: 'solid',
                        borderTopColor: '#000',

                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#000',

                        borderLeftWidth: 1,
                        borderLeftStyle: 'solid',
                        borderLeftColor: '#000',

                        borderRightWidth: 1,
                        borderRightStyle: 'solid',
                        borderRightColor: '#000',

                        // paddingTop: 55,
                        // paddingBottom: 5,
                        // paddingLeft: 4,
                        // paddingRight: 4,
                        height: 60,
                        paddingLeft: 5,
                        paddingBottom: 3,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start'
                    }}
                >

                    <Text style={[styles.h8, { marginBottom: 2, textAlign: "center" }]}>
                        Doctor Signature
                    </Text>
                </View>
                <Text style={[styles.h8, { marginTop: 3 }]}>
                    This is a computer-generated document. No signature is required.
                </Text>
            </View>

            <View style={{ width: "43%", alignItems: "right" }}>
                <View style={{ marginTop: 10, height: '100%' }}>
                    <View
                        style={{
                            borderBottomColor: '#000',
                            borderBottomStyle: 'solid',
                            borderBottomWidth: 0.5,
                            height: '100%'
                        }}
                    >
                        <Text style={[styles.h8, { paddingBottom: 5 }]}>REMARK : </Text>
                        <Text style={[styles.h10, { paddingBottom: 5 }]}>{document?.doc_remark}</Text>
                    </View>
                </View>
                {/* <Footer label={`Remark`} /> */}
                {/* <Footer label={`IC / Passport No.`} />
                <Footer label={`Date`} /> */}
            </View>
        </View>
    )
}
